import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { tap, throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[preventDoubleClick]',
})
export class PreventDoubleClickDirective implements OnInit, OnDestroy {
  @Input()
  throttleTime = 750;

  @Input()
  eventType: 'click' | 'change' = 'click';

  @Output()
  throttledClick = new EventEmitter();

  private clicks = new Subject<MouseEvent>();
  private subscription: Subscription;

  ngOnInit() {
    this.subscription = this.clicks
      .pipe(
        throttleTime(this.throttleTime),
        tap((e) => {
          this.emitThrottledClick(e);
        })
      )
      .subscribe();
  }

  emitThrottledClick(e) {
    this.throttledClick.emit(e);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('change', ['$event'])
  changeEvent(event: MouseEvent) {
    if (this.eventType !== 'change') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

  @HostListener('click', ['$event'])
  clickEvent(event: MouseEvent) {
    if (this.eventType !== 'click') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
